module.exports = __webpack_public_path__ + "img/stand_xiaoman_2_cut.98aa135f.png";